var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"SAKurukuru"},[_c('div',{staticClass:"load"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }